import { TypeNotification, Notification } from "../models/notification";
import moment from "moment";
import DOMPurify from 'dompurify';

export class NotificationService {
	private currentID = 1;
	public listNotification: Notification[] = [];
	public listNotificationHeader: Notification[] = [];

	public SendSuccess(message: string, numberSecondsDisplay = 0): void {
		this.pushNotification(TypeNotification.Success, message, numberSecondsDisplay);
	}

	public SendFailed(message: string, numberSecondsDisplay = 0): void {
		this.pushNotification(TypeNotification.Failed, message, numberSecondsDisplay);
	}

	public SendMultipleFailed(listeMessages: string[], numberSecondsDisplay = 0): void {
		listeMessages.forEach(m => this.SendFailed(m), numberSecondsDisplay);
	}

	public SendWarning(message: string, numberSecondsDisplay = 0): void {
		this.pushNotification(TypeNotification.Warning, message, numberSecondsDisplay);
	}

	public SendInformation(message: string, numberSecondsDisplay = 0): void {
		this.pushNotification(TypeNotification.Information, message, numberSecondsDisplay);
	}

	public SendFailedList(messages: string[], numberSecondsDisplay = 0): void {
		let messagesFormat = "";

		messages.forEach(function(message: string) {
			messagesFormat += message + "<br/>";
		});

		this.pushNotification(TypeNotification.Failed, messagesFormat, numberSecondsDisplay);
    }

    public SendWarningList(messages: string[], numberSecondsDisplay = 0): void {
        let messagesFormat = "";

        messages.forEach(function (message: string) {
            messagesFormat += message + "<br/>";
        });

        this.pushNotification(TypeNotification.Warning, messagesFormat, numberSecondsDisplay);
    }

	private pushNotification(typeNotification: TypeNotification, message: string, numberSecondsDisplay: number): void {
		message = DOMPurify.sanitize(message.replace(/\n/g, '<br>'));
		const notif: Notification = {
			id: this.currentID,
			type: typeNotification,
			message: message,
			isNew: true,
			time: moment(new Date()).format("HH:mm").toString(),
			numberSecondsDisplay: (numberSecondsDisplay === 0) ? 3000 : numberSecondsDisplay * 1000
		};

		this.listNotification.push(notif);
		this.listNotificationHeader.push(notif);

		this.currentID++;
	}

	public updateAllRead(): void {
		this.listNotificationHeader.forEach(function(notif) {
			notif.isNew = false;
		});
	}
}

export const NotificationServiceInstance = new NotificationService();



// WEBPACK FOOTER //
// ./src/shared/services/notification.service.ts